import { render } from "./recommendCourseList.vue?vue&type=template&id=416bb03a&scoped=true"
import script from "./recommendCourseList.vue?vue&type=script&lang=js"
export * from "./recommendCourseList.vue?vue&type=script&lang=js"

import "./recommendCourseList.vue?vue&type=style&index=0&id=416bb03a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416bb03a"]])

export default __exports__